import React from "react";
import { Home } from "lucide-react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import logo from "../../../assets/app-logo.png";

export type BrandingRole =
  | "logger"
  | "sp"
  | "showrunner"
  | "controller"
  | "contentdirector"
  | "admin"
  | "executive"
  | "editor"
  | "cliente";

interface RoleBrandingHeaderProps {
  role: BrandingRole;
  roleLabel: string;
  projectName?: string;
  onHomeClick: () => void;
  testIdPrefix?: string;
}

export const RoleBrandingHeader: React.FC<RoleBrandingHeaderProps> = ({
  role,
  roleLabel,
  projectName,
  onHomeClick,
  testIdPrefix = "branding",
}) => {
  const roleColor = `var(--color-role-${role})`;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
      <img src={logo} alt="Braindog" className="h-10 w-auto object-contain shrink-0" />
      <Breadcrumb data-testid={`${testIdPrefix}-breadcrumb`}>
        <BreadcrumbList className="text-base">
          <BreadcrumbItem>
            <BreadcrumbLink
              data-testid={`${testIdPrefix}-btn-home`}
              onClick={onHomeClick}
              className="cursor-pointer flex items-center"
              aria-label="Home"
            >
              <Home className="h-4 w-4" />
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <BreadcrumbPage
              data-testid={`${testIdPrefix}-role-label`}
              style={{ color: roleColor }}
              className="font-semibold"
            >
              {roleLabel}
            </BreadcrumbPage>
          </BreadcrumbItem>
          {projectName && (
            <BreadcrumbItem>
              <BreadcrumbPage data-testid={`${testIdPrefix}-project-badge`}>
                {projectName.toUpperCase()}
              </BreadcrumbPage>
            </BreadcrumbItem>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};
